/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-08.
 * Exports all widgets components
 */
import Pagination from './pagination';
import SnackBar from './snackbar';

export { Pagination, SnackBar };



// WEBPACK FOOTER //
// ./components/widgets/index.js